const dsBridge = require('dsbridge')
export default {
    /**
     * 前端调用app的方法回调
     * @param {string} name app方法名
     * @param {Object} data 携带参数
     * @param {function} callback 回调方法,接收app传递的数据
     */
    callHandler(name, data, callback) {
        dsBridge.call(name, data, res => {
            callback(res)
        })
    },
    /**
     * 前端查询app方法是否存在
     * @param {string} name app方法名
     */
    hasNativeMethod(name) {
        // 查询方法是否存在
        let hasNativeMethod = dsBridge.hasNativeMethod(`app.${name}`)
        let hasNativeOldMethod = window.app ? window.app[name] : ''

        return hasNativeMethod || hasNativeOldMethod
    },

    /**
     * 前端调用app的方法
     * @param {string} name app方法名
     * @param {Object} data 携带参数
     */
    callBackHandler(name, data = {}) {
        // 查询方法是否存在
        let hasNativeMethod = dsBridge.hasNativeMethod(`app.${name}`)

        if (hasNativeMethod) {
            return dsBridge.call(`app.${name}`, data)
        } else {
            // 兼容老版本存留
            let arr = []

            try {
                if (data) {
                    Object.keys(data).forEach(res => {
                        arr.push(data[res])
                    })
                }
                return window.app ? (window.app[name] ? window.app[name](...arr) : '') : ''
            } catch (e) {
                console.log(e)
            }
        }
    },
    /**
     * app调用前端方法
     * @param {string} name 前端方法名
     * @param {function} callback 回调方法,接收app传递的数据,并返回数据给app
     */
    registerHandler(name, callback) {
        dsBridge.register(name, callback)

        // 兼容老版本存留
        window[name] = callback
    }
}
